import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dataPropertyGetter' })
export class DataPropertyGetterPipe implements PipeTransform {
  transform(value): any {
    if (!value) {
      return value;
    }

    const keys = [];
    for (const key in value) {
      keys.push({ key, value: value[key] });
    }
    return keys;
  }
}
